/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable no-self-compare */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-shadow */
// FILE: components/PatientIntake/ConfirmPayment/ConfirmPayment.tsx
/* eslint-disable no-nested-ternary */
/* eslint-disable @typescript-eslint/explicit-function-return-type */

import Container from '@brands/Components/Container/Container';
import { Loading } from '@brands/Components/LoadingSpinner/Loading';
import PatientIntakeNavigation from '@brands/Components/PatientIntakeNavigation/PatientIntakeNavigation';
import OralHealthCoachingModal from '@brands/Dashboard/Dashboard/DashboardModals/OralHealthCoachingModal';
import { medicalConditionQuestionsForTags } from '@brands/Dashboard/MedicalHistory/MedicalCondition/utils/questions';
import ScheduleLiveConsultation from '@brands/Dashboard/Dashboard/DashboardModals/ScheduleLiveConsultation';
import SubmitCCConfirmationModal from '@brands/Dashboard/Dashboard/DashboardModals/SubmitCCConfirmationModal';
import SubmitCEConfirmationModal from '@brands/Dashboard/Dashboard/DashboardModals/SubmitCEConfirmationModal';
import SubmitConfirmationModal from '@brands/Dashboard/Dashboard/DashboardModals/SubmitConfirmationModal';
import SubmitSOConfirmationModal from '@brands/Dashboard/Dashboard/DashboardModals/SubmitSOConfirmationModal';
import UnavailableTimeSlotModal from '@brands/Dashboard/Dashboard/DashboardModals/UnavailableTimeSlotModal';
import { convertDateFormat, uploadMediaToCase } from '@brands/Dashboard/MyProfile/Patient/utils/utilsFunctions';
import { getUploadedFileName } from '@brands/Dashboard/PatientForms/PatientForm/utils/clinicalEnablementFlow';
import { VerificationType } from '@brands/Dashboard/PatientForms/PatientForm/PaymentInformation/InsuranceModal/InsuranceVerificationModal';
import { useWindowSize } from '@brands/hooks';
import { useAppDispatch, useAppSelector } from '@brands/hooks/useReduxHook';
import { CasePayload, createNewCase } from '@brands/services/cases/createNewCase';
import { defaultICaseValues } from '@brands/services/cases/types/defaultICaseValues';
import { CaseType, ICase, Pricing } from '@brands/services/cases/types/ICase';
import { completeMobileHandoff } from '@brands/services/communication/completeMobileHandover';
import { listClinicalData } from '@brands/services/clinical_data/listClinicalData';
import { getPricings, Pricings } from '@brands/services/identity/getPricings';
import { UserRoleName } from '@brands/services/identity/types/UserProfile';
import { selectAuth } from '@brands/store/selectors/auth';
import { selectCurrentPatientState } from '@brands/store/selectors/currentPatientState';
import { selectIsFromHandOff } from '@brands/store/selectors/isFromHandOff';
import { selectOrganization } from '@brands/store/selectors/organization';
import { selectOrganizationPrices } from '@brands/store/selectors/organizationPrices';
import { selectPatientForm } from '@brands/store/selectors/patientForm';
import { selectPatient } from '@brands/store/selectors/selectedPatient';
import { setStaffIntakeInProgress } from '@brands/store/slices/staffCaseCreationSlice';
import { setIsFromHandoff } from '@brands/store/slices/isFromHandOffSlice';
import { resetForm, resetIsFromSmileScanReport, resetSelectedPatient } from '@brands/store/slices/patientFormSlice';
import { normalizeAdditionalInfo } from '@brands/Utils/additionalInfo';
import { displayErrorDetails } from '@brands/Utils/displayError';
import { getSecondary } from '@brands/Utils/getPrimaryColor';
import { lastAmount } from '@brands/Utils/needsPayment';
import WarningIcon from '@mui/icons-material/Warning';
import { Box, Button, Typography } from '@mui/material';
import React, { useEffect, useMemo, useState } from 'react';
import { AiOutlineLeft } from 'react-icons/ai';
import { useLocation, useNavigate } from 'react-router-dom';

import { priceFor } from '../../../Dashboard/Patient/utils/helpers';
import { CollapsibleSection } from './components/CollapsibleSection';
import styles from './styles.module.scss';

const ConfirmPayment = (): JSX.Element => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { userInfo } = useAppSelector(selectAuth);
  const screenSize = useWindowSize();
  const [loading, setLoading] = useState<boolean>(false);
  const currentState: string = useAppSelector(selectCurrentPatientState);
  const { selectedPatient: currentPatient } = useAppSelector(selectPatient);
  const isFromHandoffMobile = useAppSelector(selectIsFromHandOff);
  const { values, selectedPatient } = useAppSelector(selectPatientForm);
  const { currentOrganization } = useAppSelector(selectOrganization);
  const [displayUnavailableTimeSlotModal, setDisplayUnavailableTimeSlotModal] = useState(false);
  const [scheduleModal, setScheduleModal] = useState<{ openModal: boolean; currentCase: ICase }>({
    openModal: false,
    currentCase: defaultICaseValues,
  });
  const [oralHealthCoachingModal, setOralHealthCoachingModal] = useState<{ openModal: boolean; currentCase: ICase }>({
    openModal: false,
    currentCase: defaultICaseValues,
  });
  const [submitConfirmation, setSubmitConfirmation] = useState<boolean>(false);
  const [submitSOConfirmation, setSubmitSOConfirmation] = useState(false);
  const [submitCCConfirmation, setSubmitCCConfirmation] = useState(false);
  const [submitCEConfirmation, setSubmitCEConfirmation] = useState(false);
  const [isChecked, setIsChecked] = useState(false);
  const isSubmitDisabled = !isChecked;

  const { state } = useLocation();

  const verificationType = state?.verificationType as VerificationType | undefined;

  const blockedVerificationTypes: VerificationType[] = [
    'notCovered_No',
    'notCovered_Unsure',
    'invalid_No',
    'invalid_Unsure',
  ];

  const isInvalidVerification = verificationType !== undefined && blockedVerificationTypes.includes(verificationType);

  const caseType = (values.find((item) => item.form_question_id === 20)?.value.caseType as string) || '';

  const currentOrganizationPrices = useAppSelector(selectOrganizationPrices);

  const p = priceFor(currentOrganizationPrices.currentOrganizationPrices, caseType as CaseType);

  const shouldHideSelfPay =
    p?.payment_options && p.payment_options.length === 1 && p.payment_options.includes('Insurance');

  const shouldBlockSelfPay = isInvalidVerification && shouldHideSelfPay;

  const getPlanField = <T,>(key: string): T | undefined => {
    const raw = values.find((i) => i.form_question_id === 19)?.value as unknown as unknown;
    const plan = (raw && typeof raw === 'object' && (raw as any).plan_payment) as unknown;
    if (plan && typeof plan === 'object' && key in (plan as Record<string, unknown>)) {
      return (plan as Record<string, unknown>)[key] as T;
    }
    return undefined;
  };

  const savedPaymentInformation = values.find((i) => i.form_question_id === 19)?.value as any;

  const payWithCredit: boolean =
    savedPaymentInformation?.payWithCredit === true ||
    getPlanField<boolean>('use_credit') === true ||
    getPlanField<string>('method') === 'CREDIT' ||
    getPlanField<string>('mode') === 'CREDIT';

  const creditsRemainingAfter: number | undefined =
    typeof getPlanField<number>('remaining_after') === 'number'
      ? (getPlanField<number>('remaining_after') as number)
      : typeof savedPaymentInformation?.creditsRemainingAfter === 'number'
      ? savedPaymentInformation.creditsRemainingAfter
      : undefined;

  const creditsBefore = typeof creditsRemainingAfter === 'number' ? Math.max(creditsRemainingAfter + 1, 0) : undefined;

  const currentOrganizationPrice = currentOrganizationPrices.currentOrganizationPrices?.find((price: Pricings) =>
    price.case_types.includes(values.find((item) => item.form_question_id === 20)?.value.caseType as string),
  );

  const priceInCents = lastAmount(currentOrganizationPrice);

  const priceInDollars = priceInCents / 100;

  function isSelectedAppointmentTimeIsEnough(selectedTimeSlot: string): boolean {
    const selectedTime = new Date(selectedTimeSlot);
    const currentTime = new Date();
    const diffMinutes = (selectedTime.getTime() - currentTime.getTime()) / (1000 * 60);
    return diffMinutes >= 20;
  }

  const handleReset = (): void => {
    dispatch(resetForm());
    dispatch(resetSelectedPatient());
    dispatch(resetIsFromSmileScanReport());
    dispatch(setIsFromHandoff(false));
    dispatch(setStaffIntakeInProgress(false));
  };

  /** Admin/org/super-admin/collector creating a case for the selected patient (same patient_id / dependent_id rules). */
  const isCurrentUserAdmin = useMemo(
    () =>
      userInfo.role.name === UserRoleName.Admin ||
      userInfo.role.name === UserRoleName.SuperAdmin ||
      userInfo.role.name === UserRoleName.OrganizationAdmin ||
      userInfo.role.name === UserRoleName.Collector ||
      userInfo.role.name === UserRoleName.CareAdvisor,
    [userInfo.role.name],
  );

  // Care Coordination and Second Opinion are Self-payable regardless of the
  // org's pricing.payment_options config (see the matching carve-out in
  // PaymentInformation.tsx). Without it, an org with no configured payment
  // options for these case types makes isPaymentRequired false here, which
  // forces payment_profile_id/insurance_id to null below even though a real
  // payment profile was just captured — the backend then rejects the case
  // with "[10100-2] Insurance or payment profile is required" (DO-4527).
  const isPaymentRequired =
    (currentOrganizationPrices.currentOrganizationPrices?.find((pricing: Pricing) =>
      pricing.case_types.includes(values.find((item) => item.form_question_id === 20)?.value.caseType as string),
    )?.payment_options?.length ?? 0) > 0 ||
    caseType === CaseType.second_opinion ||
    caseType === CaseType.care_coordination;

  // Backend only accepts this fixed vocabulary for substance_use — the form
  // itself stores its own display strings (see ClinicalDataStepSix.tsx),
  // which don't match, so they need translating rather than passed through.
  // There's no "Alcohol" checkbox in the current intake form at all; it's
  // listed here so it maps correctly if/when one is added.
  const SUBSTANCE_USE_LABELS: Record<string, string> = {
    'Tobacco Products': 'Tobacco',
    'Recreational Drugs': 'Drugs',
    'Prescription medication for non-medical reasons': 'Drugs',
    Alcohol: 'Alcohol',
  };

  const LAST_DENTIST_VISIT_LABELS: Record<string, string> = {
    within6Months: 'Within 6 months',
    'Within 6 months': 'Within 6 months',
    sixToTwelveMonths: '6-12 months ago',
    '6-12 months ago': '6-12 months ago',
    oneToTwoYears: '1-2 years ago',
    '1-2 years ago': '1-2 years ago',
    moreThanTwoYears: 'More than 2 years ago',
    'More than 2 years ago': 'More than 2 years ago',
    never: 'Never',
    Never: 'Never',
    dontKnow: "I don't know",
    "I don't know": "I don't know",
  };

  const asNonEmptyText = (value: unknown, fallback = 'None'): string => {
    if (typeof value === 'string' && value.trim()) return value.trim();
    if (Array.isArray(value) && value.length) return value.join(', ');
    return fallback;
  };

  const asStringArray = (value: unknown): string[] => {
    if (Array.isArray(value)) {
      return value.filter((item): item is string => typeof item === 'string' && item.trim().length > 0);
    }
    return typeof value === 'string' && value.trim() ? [value.trim()] : [];
  };

  const buildClinicalEnablementIntakeAnswers = async (): Promise<Record<string, unknown>> => {
    const clinicalDataPatientId = Number(selectedPatient?.value) || Number(userInfo.id);
    const { medical_conditions, medical_history, dental_history } = await listClinicalData(clinicalDataPatientId);

    const selectedConditions = medicalConditionQuestionsForTags
      .filter(
        (question) => question.id !== 'conditions_not_listed' && question.id !== 'medical_condition_none_of_the_above',
      )
      .filter((question) => Boolean((medical_conditions as Record<string, unknown>)?.[question.id]))
      .map((question) => question.title);

    if (medical_conditions?.conditions_not_listed) {
      selectedConditions.push(medical_conditions.conditions_not_listed);
    }
    if (selectedConditions.length === 0) selectedConditions.push('None');

    const whoIsAppointmentFor =
      Number(selectedPatient?.value) === Number(userInfo.id) ? 'Myself' : selectedPatient?.label || 'Myself';

    const substanceUse = medical_history?.using_substances?.length
      ? Array.from(
          new Set(medical_history.using_substances.map((substance) => SUBSTANCE_USE_LABELS[substance] || substance)),
        ).filter((substance) => ['Tobacco', 'Drugs', 'Alcohol'].includes(substance))
      : ['None'];

    const lastDentistVisit = LAST_DENTIST_VISIT_LABELS[dental_history?.last_dental_visit || ''] || "I don't know";
    const reasonForVisit = asStringArray(dental_history?.visit_type);
    const additionalInfo = normalizeAdditionalInfo(
      values.find((item) => item.form_question_id === 16)?.value.additionalInfo,
    );
    const uploadedFileName = getUploadedFileName(values);

    const answers: Record<string, unknown> = {
      who_is_appointment_for: whoIsAppointmentFor,
      // Always-required per the backend's seeded intake question for this
      // case type — there's no "unless file uploaded" exception for it, and
      // no UI in the current wizard captures it, so it's hardcoded.
      appointment_location: 'Home',
      ...(uploadedFileName && { file_upload: uploadedFileName }),
      ...(additionalInfo && { note_to_dentist: additionalInfo }),
      medical_conditions: selectedConditions,
      under_physician_care: Boolean(medical_history?.under_care_of_physician),
      medications: medical_history?.taking_medication
        ? asNonEmptyText(medical_history?.medications, 'Yes — details not provided')
        : 'None',
      allergies: medical_history?.allergic_to_medications
        ? asNonEmptyText(medical_history?.medications_allergies, 'Yes — details not provided')
        : 'None',
      substance_use: substanceUse,
      quitting_products: Boolean(medical_history?.interested_in_stopping),
      height: asNonEmptyText(medical_history?.height, 'N/A'),
      weight: asNonEmptyText(medical_history?.weight, 'N/A'),
      last_dentist_visit: lastDentistVisit,
      dentist_seen: asNonEmptyText(dental_history?.who_did_you_see, "I don't know"),
      reason_for_visit: reasonForVisit.length ? reasonForVisit : ['None'],
    };

    if (medical_history?.under_care_of_physician) {
      answers.physician_conditions = asNonEmptyText(medical_history?.conditions_treated, 'Details not provided');
    }

    return answers;
  };

  const createCaseForThisRequirement = async (): Promise<ICase> => {
    const caseType = (values.find((item) => item.form_question_id === 20)?.value.caseType as string) || '';
    const intakeAnswers =
      caseType === CaseType.clinical_enablement ? await buildClinicalEnablementIntakeAnswers() : undefined;
    const payload: CasePayload = {
      type: caseType,
      status: 'new',
      patient_id: isCurrentUserAdmin
        ? currentPatient.guardian_id == null
          ? currentPatient?.id
          : currentPatient.guardian_id!
        : Number(userInfo.id),
      organization_id: currentOrganization?.id || 'dentistry-one',
      ...((values.find((item) => item.form_question_id === 20)?.value.caseType as string) !==
        CaseType.oral_health_coaching && {
        provider_id:
          (values.find((item) => item.form_question_id === 20)?.value.caseType as string) === 'video_call_scheduled' ||
          (values.find((item) => item.form_question_id === 20)?.value.caseType as string) ===
            CaseType.phone_call_scheduled
            ? Number(values.find((item) => item.form_question_id === 14)?.value?.selectedProviderId)
            : undefined,
      }),
      ...((values.find((item) => item.form_question_id === 20)?.value.caseType as string) ===
        CaseType.oral_health_coaching && {
        care_advisor_id: Number(values.find((item) => item.form_question_id === 14)?.value?.selectedCareAdvisorId),
      }),
      payment_profile_id:
        isPaymentRequired || shouldBlockSelfPay
          ? savedPaymentInformation?.paymentId
            ? Number(savedPaymentInformation?.paymentId)
            : null
          : null,
      video_conference_date: (values.find((item) => item.form_question_id === 14)?.value?.selectedTimeSlot as string)
        ? convertDateFormat(values.find((item) => item.form_question_id === 14)?.value?.selectedTimeSlot as string)
        : null,
      patient_current_state: isCurrentUserAdmin
        ? currentState[currentPatient.id] || ''
        : currentState[userInfo.id] || '',
      ...(isPaymentRequired && {
        insurance_id: savedPaymentInformation?.insuranceId ? Number(savedPaymentInformation?.insuranceId) : null,
      }),
      ...(isPaymentRequired &&
        savedPaymentInformation?.usedInsuranceId && {
          used_insurance_id: Number(savedPaymentInformation?.usedInsuranceId),
        }),
      ...(isPaymentRequired &&
        savedPaymentInformation?.addSecondaryInsurance &&
        savedPaymentInformation?.secondaryInsuranceId !== '' && {
          second_insurance_id: savedPaymentInformation?.addSecondaryInsurance
            ? Number(savedPaymentInformation?.secondaryInsuranceId)
            : undefined,
        }),
      dependent_id: isCurrentUserAdmin
        ? currentPatient.guardian_id == null
          ? null
          : Number(currentPatient?.id)
        : Number(selectedPatient?.value) !== Number(userInfo.id)
        ? Number(selectedPatient?.value)
        : null,
      case_intake_questions: {
        is_dental_emergency: values.find((item) => item.form_question_id === 16)?.value.experiencingEmergency === true,
        in_pain: values.find((item) => item.form_question_id === 16)?.value.inPain === 'yes',
        pain_description: (values.find((item) => item.form_question_id === 16)?.value.describePain as string[]) || [],
        pain_time: (values.find((item) => item.form_question_id === 16)?.value.daysInPain as string) || '',
        pain_level: (values.find((item) => item.form_question_id === 16)?.value.painLevel as string) || '',
        reason_for_visit: (values.find((item) => item.form_question_id === 16)?.value.reasonForVisit as string[]) || [],
        additional_info: (values.find((item) => item.form_question_id === 16)?.value.additionalInfo as string) || '',
      },

      // 👇 NEW — let the backend decide whether to consume a credit
      ...({ pay_with_credits: payWithCredit } as any),

      // Non-breaking hint for backend about payment via plan credit (only set when selected)
      ...(payWithCredit && {
        plan_payment: {
          method: 'CREDIT',
          // Reserve/record intent only; deduction should happen upon case completion.
          credits_before: creditsBefore,
          credits_after: creditsRemainingAfter,
        },
      }),

      tz: Intl.DateTimeFormat().resolvedOptions().timeZone,
      ...(((values.find((item) => item.form_question_id === 20)?.value.caseType as string) === CaseType.one_report ||
        (values.find((item) => item.form_question_id === 20)?.value.caseType as string) ===
          CaseType.second_opinion) && {
        license_states: isCurrentUserAdmin ? [currentState[currentPatient.id] || ''] : [currentState[userInfo.id]],
      }),
      ...(intakeAnswers && { intake_answers: intakeAnswers }),
    };

    const caseRes = await createNewCase(payload, userInfo.role.name);
    return caseRes;
  };

  const completeMobileHandoffFn = async (): Promise<void> => {
    try {
      await completeMobileHandoff();
      dispatch(setIsFromHandoff(false));
    } catch (error: unknown) {
      displayErrorDetails(error);
    }
  };

  const dispatchSuccessEvent = (serviceType: string): void => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'thank-you-screen-shown',
      service: serviceType,
      userId: userInfo.id,
    });
  };

  const onSubmit = async (): Promise<any> => {
    const slot = values.find((item) => item.form_question_id === 14)?.value?.selectedTimeSlot as string;
    const caseType = values.find((item) => item.form_question_id === 20)?.value.caseType as string;

    if ((caseType === CaseType.video_call_scheduled || caseType === CaseType.phone_call_scheduled) && slot) {
      if (!isSelectedAppointmentTimeIsEnough(slot)) {
        setDisplayUnavailableTimeSlotModal(true);
        return;
      }
    }

    if (!caseType) return;

    setLoading(true);
    try {
      const res = await createCaseForThisRequirement();

      if (isFromHandoffMobile) {
        await completeMobileHandoffFn();
      }

      const imagesValue = values.find((item) => item.form_question_id === 17)?.value.images;
      if (Array.isArray(imagesValue)) {
        // Await so the media is attached to the case's one_report before we
        // navigate to the confirmation modal / consultation page. Without
        // this, Care Advisor and Collector intakes can race the navigation
        // and the consultation page renders before any image is attached.
        await uploadMediaToCase(res, imagesValue, userInfo.role.name);
      }

      // Route to the appropriate confirmation modal
      if (res && (res.type === 'video_call_scheduled' || res.type === CaseType.phone_call_scheduled)) {
        dispatchSuccessEvent('talk-live-scheduled');
        setScheduleModal({ openModal: true, currentCase: res });
        return;
      }
      if (res && res.type === CaseType.care_coordination) {
        dispatchSuccessEvent('care_coordination');
        setSubmitCCConfirmation(true);
        return;
      }
      if (res && res.type === CaseType.oral_health_coaching) {
        dispatchSuccessEvent('oral_health_coaching');
        setOralHealthCoachingModal({ openModal: true, currentCase: res });
        return;
      }
      if (res && res.type === 'one_report') {
        dispatchSuccessEvent('send-photos');
        setSubmitConfirmation(true);
        return;
      }
      if (res && res.type === 'second_opinion') {
        dispatchSuccessEvent('second-opinion');
        setSubmitSOConfirmation(true);
        return;
      }
      if (res && res.type === CaseType.clinical_enablement) {
        dispatchSuccessEvent('clinical-enablement');
        setSubmitCEConfirmation(true);
        return;
      }

      if (res) {
        handleReset();
      }
    } catch (error: unknown) {
      displayErrorDetails(error);
    } finally {
      dispatch(setStaffIntakeInProgress(false));
      setLoading(false);
    }
  };

  if (loading) return <Loading fullScreen />;

  return (
    <Container
      isVisibleOnMobile
      containerStyle={{ justifyContent: screenSize.width >= 564 ? 'center' : 'start' }}
      childrenStyle={{ zIndex: '2', paddingTop: screenSize.width > 768 ? '40px' : '16px' }}
      isSidenavVisible={false}
      isIntakeProcess
    >
      <div className={styles.patientFormContainer}>
        <PatientIntakeNavigation progress={100} />
        <form className={styles.formContainer}>
          <div className={styles.wrapper}>
            <div className={styles.formContent}>
              <span className={`fs-unmask ${styles.paymentInfoTitle}`} data-testid="confirm-payment-title">
                Confirm payment and schedule
              </span>

              <Box className={`fs-unmask ${styles.confirmPaymentContainer}`} data-testid="confirm-payment-cost-div">
                {!payWithCredit ? (
                  <>
                    <Typography
                      className={`fs-unmask ${styles.confirmPaymentContainerEstimated}`}
                      color="text.secondary"
                    >
                      {savedPaymentInformation &&
                      savedPaymentInformation.insuranceId !== '' &&
                      savedPaymentInformation.medicaidAnswer !== '' &&
                      savedPaymentInformation.medicaidAnswer !== 'yes'
                        ? 'Estimated cost of this visit'
                        : 'Cost of this Visit'}
                    </Typography>

                    <Typography
                      className={`fs-unmask ${styles.confirmPaymentContainerEstimatedPrice}`}
                      variant="h3"
                      fontWeight="bold"
                      data-testid="confirm-payment-cost"
                    >
                      {savedPaymentInformation && savedPaymentInformation.paymentId !== ''
                        ? `$${priceInDollars.toFixed(2)}`
                        : '$0.00'}
                    </Typography>
                  </>
                ) : (
                  <>
                    <Typography
                      className={`fs-unmask ${styles.confirmPaymentContainerEstimated}`}
                      color="text.secondary"
                      data-testid="confirm-payment-covered-label"
                    >
                      Cost of this Visit
                    </Typography>
                    <Typography
                      className={`fs-unmask ${styles.confirmPaymentContainerEstimatedPrice}`}
                      variant="h3"
                      fontWeight="bold"
                      data-testid="confirm-payment-covered-value"
                    >
                      Covered by your plan
                    </Typography>

                    {typeof creditsRemainingAfter === 'number' && (
                      <Typography
                        className={`fs-unmask ${styles.confirmPaymentContainerEstimatedMaxPrice}`}
                        sx={{ borderBottom: '1px solid #E0E0E0', py: 1, width: '100%', paddingBottom: '16px' }}
                        color="text.secondary"
                        mt={2}
                        data-testid="confirm-payment-credits-remaining"
                      >
                        You’ll have{' '}
                        <strong>{creditsRemainingAfter === Infinity ? 'unlimited' : creditsRemainingAfter}</strong>{' '}
                        {creditsRemainingAfter === 1 ? 'credit' : 'credits'} remaining after this service.
                      </Typography>
                    )}

                    <CollapsibleSection title="How plan credits work">
                      We'll reserve one credit for this visit. Your credit will be{' '}
                      <strong>deducted only after the visit is completed</strong>. If the case is canceled, your credit
                      will be returned to you automatically.
                      <br />
                      <br />
                      If you're on an unlimited plan, this visit won't use any credits.
                    </CollapsibleSection>
                  </>
                )}

                {!payWithCredit &&
                  savedPaymentInformation &&
                  savedPaymentInformation.insuranceId !== '' &&
                  savedPaymentInformation.medicaidAnswer !== '' &&
                  savedPaymentInformation.medicaidAnswer !== 'yes' && (
                    <>
                      <Typography
                        className={`fs-unmask ${styles.confirmPaymentContainerEstimatedMaxPrice}`}
                        sx={{ borderBottom: '1px solid #E0E0E0', py: 1, width: '100%', paddingBottom: '16px' }}
                        color="text.secondary"
                        mt={2}
                        data-testid="confirm-payment-max-cost"
                      >
                        Maximum out of pocket cost: <span>$100</span>
                      </Typography>

                      <CollapsibleSection
                        title="How does insurance billing work?"
                        data-testid="confirm-payment-how-billing-work"
                      >
                        You’ll be paying our estimated out-of-pocket cost upfront, which includes your copay and
                        deductible (if available). After your visit, your insurance will process the claim and determine
                        if there’s any remaining balance.
                        <br />
                        <br />
                        If an additional balance is due, we’ll send you a bill via email and/or SMS. You’ll have 30 days
                        to pay the balance online.
                      </CollapsibleSection>

                      <CollapsibleSection title="Why is this an estimate?" data-testid="confirm-payment-why-estimate">
                        <ol style={{ listStyle: 'decimal', paddingLeft: '20px', margin: 0 }}>
                          <li style={{ display: 'list-item', listStyleType: 'decimal' }}>
                            Insurance benefits can differ between plans.
                          </li>
                          <li style={{ display: 'list-item', listStyleType: 'decimal' }}>
                            Deductible amounts are often not available in real-time.
                          </li>
                          <li style={{ display: 'list-item', listStyleType: 'decimal' }}>
                            The final cost depends on what your provider covers during the visit, which may vary based
                            on your individual case.
                          </li>
                        </ol>
                        <br />
                        Need help? Our support team is available Monday through Friday from 9:00am to 5:00pm ET{' '}
                        <Typography
                          component="a"
                          href="tel:+18777127875"
                          sx={{ color: getSecondary(), textDecoration: 'none' }}
                        >
                          +1 (877) 712-7875
                        </Typography>
                      </CollapsibleSection>
                    </>
                  )}

                <div
                  className={`fs-unmask ${styles.confirmPaymentContainerWarningDiv}`}
                  data-testid="confirm-payment-missed-appointment-div"
                >
                  <Typography
                    className={`fs-unmask ${styles.confirmPaymentContainerWarning}`}
                    variant="body1"
                    color="error"
                    fontWeight="bold"
                    mb={1}
                    mt={2}
                    data-testid="confirm-payment-missed-appointment"
                  >
                    <WarningIcon /> Missed appointments
                  </Typography>
                  <Typography
                    className={`fs-unmask ${styles.confirmPaymentContainerWarningText}`}
                    variant="body1"
                    color="error"
                    mb={2}
                  >
                    If you miss your scheduled appointment time, we reserve the right to charge for the full amount. You
                    can cancel your appointment for free up to 1 hour before it starts.
                  </Typography>
                </div>
              </Box>

              <Box
                className={`fs-unmask ${styles.confirmPaymentContainerAcceptText}`}
                data-testid="confirm-payment-accept"
              >
                <input
                  className={`form-check-input fs-unmask ${styles.checkInput} mt-0 ${
                    isChecked ? styles.primaryColor : ''
                  }`}
                  type="checkbox"
                  id="consent"
                  checked={isChecked}
                  onChange={(e) => setIsChecked(e.target.checked)}
                  data-testid="confirm-payment-accept-input"
                />
                <label htmlFor="consent" data-testid="confirm-payment-accept-label" className="fs-unmask">
                  By clicking “confirm payment”, I agree to Dentistry.One’s{' '}
                  <a
                    target="_blank"
                    href={`${window.location.origin}/consent-policy`}
                    style={{ color: getSecondary() }}
                    rel="noreferrer"
                  >
                    consent policy
                  </a>{' '}
                  and{' '}
                  <a
                    target="_blank"
                    href={`${window.location.origin}/notice-of-privacy-practices`}
                    style={{ color: getSecondary() }}
                    rel="noreferrer"
                  >
                    notice of privacy practices
                  </a>
                  .
                </label>
              </Box>

              <div className={styles.btnContainer}>
                <div className={styles.paymentSectionButtonDiv}>
                  <Button
                    variant="text"
                    type="button"
                    className={`fs-unmask ${styles.backBtnSticky}`}
                    onClick={() => navigate(-1)}
                    data-testid="confirm-payment-back"
                  >
                    <AiOutlineLeft /> Back
                  </Button>
                  <Button
                    type="button"
                    variant="contained"
                    className={`fs-unmask ${styles.nextBtnSticky}`}
                    disabled={isSubmitDisabled}
                    data-testid="payment-information-form-submit"
                    onClick={() => onSubmit()}
                  >
                    {payWithCredit ? 'Confirm & Schedule' : 'Confirm Payment'}
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </form>

        {scheduleModal.openModal && <ScheduleLiveConsultation newCase={scheduleModal.currentCase} />}
        {submitConfirmation && <SubmitConfirmationModal />}
        {submitSOConfirmation && <SubmitSOConfirmationModal />}
        {oralHealthCoachingModal.openModal && <OralHealthCoachingModal newCase={oralHealthCoachingModal.currentCase} />}
        {displayUnavailableTimeSlotModal && (
          <UnavailableTimeSlotModal setDisplayUnavailableTimeSlotModal={setDisplayUnavailableTimeSlotModal} />
        )}
        {submitCCConfirmation && <SubmitCCConfirmationModal />}
        {submitCEConfirmation && <SubmitCEConfirmationModal />}
      </div>
    </Container>
  );
};

export default ConfirmPayment;
